type WaitFn<E extends string, M extends Record<string, unknown>> = {
  mockResolvedValue(mockOperation: {
    operationId: string;
    userId: string;
    operationType: string;
    isSuccess: boolean;
    timestamp: string;
  }): unknown;
  (eventName: E): Promise<M>;
  (eventName: E, timeoutMs: number): Promise<M | null>;
};

type SubscribeFn<E extends string, M extends Record<string, unknown>> = (
  eventName: E,
  cb: (msg: M) => void,
) => () => void;

export const waitForNotifierEventFactory =
  <E extends string, M extends Record<string, unknown>>(subscribe: SubscribeFn<E, M>): WaitFn<E, M> =>
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-expect-error
  (eventName: E, timeoutMs?: number) => {
    return new Promise((resolve) => {
      let timer: NodeJS.Timeout | undefined;
      const unsub = subscribe(eventName, (msg) => {
        if (timer) clearTimeout(timer);
        resolve(msg);
      });

      if (timeoutMs !== undefined) {
        timer = setTimeout(() => {
          unsub();
          resolve(null);
        }, timeoutMs);
      }
    });
  };
